import { Injectable } from '@angular/core';
import { E5ConfigurationService } from 'e5core-angular-services';
import { Guid } from 'guid-typescript';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { WorkAttachmentsFrameModel, WorkAttachmentsDtoModel } from '../models/work-attachments.model';
import { OdataOptions } from './odata-options';

@Injectable({
  providedIn: 'root'
})
export class AttachmentsOdataService {

  constructor(private http: HttpClient, private config:E5ConfigurationService) { }

  // apiServer: {
  //   baseUrl: 'http://vlane5dev2016:84',
  //   scope: 'test'
  // }
  // e.g. http://localhost:12661/site/odata/Ui/Attachments/8b50f520-cac0-11e8-a32f-00155d2a720c?$count=true&$top=2&$skip=2
  //
  // {
  //   "$id": "1",
  //   "metaData": null,
  //   "id": 1117,
  //   "attachmentId": "630",
  //   "workId": "84ef573a-d293-11e8-967f-005056ba65e4",
  //   "documentName": "20181030133835358_test.pdf",
  //   "parentId": 0,
  //   "attachmentTypeId": 0
  // },
  public getWorkAttachments(workId:string, page:number, pagesize:number, options? : OdataOptions ):BehaviorSubject<WorkAttachmentsFrameModel> {
    let subject$ = new BehaviorSubject<WorkAttachmentsFrameModel>(new WorkAttachmentsFrameModel()) ;
    let baseUrl = this.config.settings.apiServer.baseUrl ;
    let scope = this.config.settings.apiServer.scope ;
    let offset = page * pagesize ;
    let url = `${baseUrl}/${scope}/odata/Ui/Attachments/${workId.toString()}?$count=true&$top=${pagesize||10}&$skip=${offset||0}` ;

    // Append orderby
    if(options && options.orderby && options.orderby !== "")
      url += `&$orderby=${encodeURIComponent(options.orderby)}` ;

    this.http.get<WorkAttachmentsDtoModel>(url).subscribe(
      result => {
        let whf = new WorkAttachmentsFrameModel() ;
        whf.count = result["@odata.count"] ;
        whf.page = page ;
        whf.pagesize = pagesize ;
        whf.data = result.value ;
        subject$.next(whf) ;
      },
      error => {
        console.error(error);
        subject$.error(error) ;
      }
    )
    return (subject$);
  }
}
